import {defineMessages} from "react-intl";

const messages = defineMessages({
    yes:{
	id:"app.admin-status-update-pharmacy-modal.yes",
	description:"yes",
	defaultMessage:"UPDATE"
    },
    
    statusUpdate:{
	id:"app.admin-status-update-pharmacy-modal.statusUpdate",
	description:"Update Status",
	defaultMessage:"Update Pharmacy Status"
    },

    status:{
	id:"app.admin-status-update-pharmacy-modal.status",
	description:"Status",
	defaultMessage:"Status* "
    },

    reasonDoc:{
	id:"app.admin-status-update-pharmacy-modal.reasonDoc",
	description:"reason Doc",
	defaultMessage:"Reason Document* "
    }
});

export default messages;
